export const BORDER_COLORS = {
  default: "#CCCCCC",
  info: "#0F56CA",
  warning: "#DAA520",
  success: "#87E8AD",
  focused: "#86b7fe",
  hover: "#86b7fe",
  main: "#0000001f",
  error: "#CA2B2B"
};

export const BG_COLORS = {
  default: "#FFFFFF",
  success: "#DCFCE7",
  info: "#EBF6FF",
  warning: "#FEF3C7",
  primary: "#0F56CA",
  error: "#CA2B2B"
};

export const FONT_COLORS = {
  default: "#333333",
  success: "#15803D",
  warning: "#B45309",
  info: "#1D4ED8",
  label: "#484848",
  white: "#FFFFFF",
  light: "#d8d8d8",
  subheading: "#8c8c8c",
  error: "#CA2B2B"
};

export const TOOLTIP_COLORS = {
  background: "#000",
  text: "#FFFFFF",
};

export const BUTTON_COLORS = {
  primary: "#0F56CA",
  primaryBorder: "#0F56CA",
  primaryHover: "#155eef",
  primaryText: "#FFFFFF",
  secondary: "#FFFFFF",
  secondaryBorder: "#0F56CA",
  secondaryText: "#0F56CA",
  secondaryHover: "#EBF6FF",
  default: "#181D1F05",
  defaultBorder: BORDER_COLORS.default,
  defaultText: FONT_COLORS.default,
  defaultHover: "#181D1F15",
  alpha: 80,
};

export const SWITCH_COLORS = {
  background: "#0F56CA",
  trackBackground: "#E9E9EA",
  checkedThumbBackground: "#FFFFFF",
};

export const TABLE_COLORS = {
  border: "#dcdddd",
  headerBackground: "#f3f3f3",
  primaryBackground: "#fff",
  secondaryBackground: "#fafafa",
  columnHeader: "#FAFAFB",
  rowHover: "rgba(33,150,243,0.12)",
  rowBackground: "#FFFFFF",
};

export const CHECKBOX_COLORS = {
  uncheckedBackgroundColor: "transparent",
  uncheckedBorderColor: BORDER_COLORS.default,
  checkedBackgroundColor: "transparent",
  checkedBorderColor: BORDER_COLORS.default,
  checkedShapeColor: "#155EEF",
  hoverBackgroundColor: "#181D1F15",
};

export const STATUS_COLORS = {
  success: "#11843c",
  pending: "#d18f00",
  rejected: "#c50000",
};
